import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import {
  ErrorMessage,
  Field,
  FieldArray,
  Form,
  Formik,
} from 'formik';
import * as yup from 'yup';
import {
  Row,
  Col,
  ControlLabel,
  FormGroup,
  FormControl,
  Checkbox,
  Alert,
  Button,
} from 'react-bootstrap';
import LoadingButton from '../../components/LoadingButton/LoadingButton';
import PageLoading from '../../components/PageLoading/PageLoading';
import {
  Portlet,
  PortletBody,
  PortletCaption,
  PortletTitle,
} from '../../components/Bootstrap/Portlet';
import { withTranslation } from 'react-i18next';

class MixDesignForm extends Component {
  constructor(props) {
    super(props);

    this.timer = null;
    this.state = {
      error: null,
    };
  }

  componentWillMount() {
    const { materialStore } = this.props;
    materialStore.loadMaterials();
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  isOnlineMix = () => {
    const { selectedId, getOnlineMixById } = this.props.mixStore;
    return !!getOnlineMixById(selectedId);
  };

  render() {
    const { mixStore, materialStore, notifierStore, t } = this.props;
    const { selectedId, getMixDesign, updateMixDesign, addMixDesign } = mixStore;
    const { assignedMaterials } = materialStore;

    return (
      <Portlet>
        <PortletTitle>
          <PortletCaption>{t('Mix design')} #{selectedId}</PortletCaption>
        </PortletTitle>
        <PortletBody>
          <div>
            <Formik
              enableReinitialize
              initialValues={
                !selectedId
                  ?  {
                    mixDesign: [{
                      id: Date.now(),
                      constituentItemId: '',
                      constituentItemCode: '',
                      quantity: 0,
                      dosQuantity: 0,
                      byPercent: false,
                      order: 1,
                      mixItemId: '',
                    }],
                  }
                  : { mixDesign: getMixDesign(selectedId) }
              }
              validationSchema={yup.object().shape({
                mixDesign: yup.array().of(
                  yup.object().shape({
                    constituentItemId: yup.string().required('Required!'),
                  })
                ),
              })}
              onSubmit={(values, actions) => {
                this.setState({
                  error: null,
                });
                values.mixDesign.forEach((v, i) => {
                  values.mixDesign[i].order = i+1;
                });
                let promise;
                if (this.isOnlineMix()) {
                  promise = updateMixDesign(values.mixDesign, selectedId);
                } else {
                  promise = addMixDesign(values.mixDesign, selectedId);
                }

                promise
                  .then(() => {
                    actions.setSubmitting(false);
                    notifierStore.showSuccess('Mix Design saved!');
                  })
                  .catch((e) => {
                    this.setState({
                      error: `Couldn't save: ${e.message}`,
                    });
                    this.timer = setTimeout(() => {
                      this.setState({
                        error: null,
                      });
                    }, 7000);
                    actions.setValues(values);
                    actions.setSubmitting(false);
                  });

              }
              }
            >{({ handleChange,
                setFieldValue,
                values,
                isSubmitting,
              }) => (
                <Form className={'mix-design-form'}>
                  {isSubmitting &&
                  <PageLoading/>
                  }
                  <FieldArray
                    name="mixDesign"
                    render={arrayHelpers => (
                      <div>
                        {values.mixDesign && values.mixDesign.length > 0 ? (
                          values.mixDesign.map((item, index) => (

                            <Row key={index}>
                              <Col sm={3}>
                                <FormGroup>
                                  <ControlLabel>{t('Material')}</ControlLabel>
                                  <FormControl
                                    name={`mixDesign.${index}.constituentItemId`}
                                    componentClass="select"
                                    value={values.mixDesign[index].constituentItemId || ''}
                                    onChange={e => {
                                      setFieldValue(`mixDesign.${index}.constituentItemId`, Number(e.target.value));
                                      setFieldValue(`mixDesign.${index}.constituentItemCode`, assignedMaterials.find(v => v.itemId === Number(e.target.value)).code);
                                      setFieldValue(`mixDesign.${index}.mixItemId`, selectedId);
                                    }}
                                    bsSize="sm"
                                  >
                                    {assignedMaterials.map(option => (
                                      <option key={option.itemId} value={option.itemId}>
                                        {option.code}
                                      </option>
                                    ))}
                                    <option value={values.mixDesign[index].constituentItemId || ''}>
                                      {values.mixDesign[index].constituentItemCode || ''}
                                    </option>
                                  </FormControl>
                                  <ErrorMessage component="span" name={`mixDesign.${index}.constituentItemId`} className="help-block" />
                                </FormGroup>
                              </Col>
                              <Col sm={3}>
                                <FormGroup>
                                  <ControlLabel>{t('Qty')}</ControlLabel>
                                  <Field name={`mixDesign.${index}.quantity`}
                                    placeholder="Qty"
                                    type="number"
                                    value={values.mixDesign[index].quantity || 0}
                                    className="form-control input-sm" />
                                  <ErrorMessage component="span" name={`mixDesign.${index}.quantity`} className="help-block" />
                                </FormGroup>
                              </Col>
                              <Col sm={3}>
                                <FormGroup>
                                  <ControlLabel>{t('Order')}</ControlLabel>
                                  <Field name={`mixDesign.${index}.order`}
                                    placeholder="Order"
                                    type="number"
                                    disabled={true}
                                    value={values.mixDesign[index].order || index+1}
                                    className="form-control input-sm" />
                                  <ErrorMessage component="span" name={`mixDesign.${index}.order`} className="help-block" />
                                </FormGroup>
                              </Col>
                              <Col sm={2}>
                                <FormGroup>
                                  <ControlLabel>{t('By/c')}</ControlLabel>
                                  <Checkbox
                                    inline
                                    className={'mt-checkbox mt-checkbox-outline'}
                                    name={`mixDesign.${index}.byPercent`}
                                    value={values.mixDesign[index].byPercent}
                                    checked={!!values.mixDesign[index].byPercent}
                                    onChange={handleChange}
                                  >
                                    <span />
                                  </Checkbox>
                                </FormGroup>
                              </Col>
                              <Col sm={1}>
                                <a className="btn btn-sm btn-default btn-action pull-right"
                                  title={t('Remove')}
                                  onClick={() => arrayHelpers.remove(index)}>
                                  <i className="fa fa-remove"/>
                                </a>
                              </Col>

                            </Row>

                          ))
                        ) : '' }
                        <Row>
                          <Col sm={3}>
                            <a className="btn btn-sm btn-default btn-add"
                              title="Add mix design" onClick={() => arrayHelpers.push({
                                constituentItemId: '',
                                quantity: '',
                                dosQuantity: '',
                                byPercent: '',
                                order: '',
                                id: Date.now(),
                              })}>
                              <i className="fa fa-plus"/>
                            </a>
                          </Col>
                        </Row>
                      </div>
                    )}
                  />
                  <Row>
                    <Col sm={12} className="text-right">
                      {!!this.state.error && <Alert bsStyle="danger">{this.state.error}</Alert>}
                      <Button onClick={this.props.onCancel}>{t('Close')} </Button>
                      {' '}
                      <LoadingButton
                        bsStyle="primary"
                        type="submit"
                        label={t('Save')}
                        loadingLabel={t('Save')}
                        isLoading={isSubmitting}
                      />
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </div>
        </PortletBody>
      </Portlet>
    );
  }
}

export default withTranslation()(inject('mixStore', 'materialStore', 'notifierStore')(observer(MixDesignForm)));
